import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { Tooltip } from "primereact/tooltip";
import { classNames } from "primereact/utils";
import { useContext, useEffect, useState } from "react";
import { Controller, set, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate, useOutletContext } from "react-router-dom";
import NoInfo from "../../components/NoInfo";
import PrimeTableFooter from "../../components/PrimeTableFooter";
import { SystemLoading, checkLoading } from "../../store/loadingStore";
import { getCompanyList, queryProductProcessList } from "../../utility/service/cbam-service";
import { checkDpSuccess, getCompanyType, getFormErrorMessage } from "../../utility/service/tool-service";

export default function ProductProcessSettingsIndex() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const {
    action,
    setAction,
    itemObj,
    setItemObj,
    currentCompanySeq,
    setCurrentCompanySeq,
    selectPlaceList,
    setSelectPlaceList,
    currentCompanyName,
    setCurrentCompanyName,
  } = useOutletContext();
  const [, loading] = useContext(SystemLoading);
  const [companyPlaceList, setCompanyPlaceList] = useState([]);
  const [rows, setRows] = useState([]);
  const [lastRowsSeq, setLastRowsSeq] = useState("");
  const [existPlaceList, setExistPlaceList] = useState([]);
  const [delDialog, setDelDialog] = useState(false);
  const [delObj, setDelObj] = useState({});
  const [tooltipTarget, setTooltipTarget] = useState(null);

  const {
    getValues,
    setValue,
    watch,
    control,
    register,
    trigger,
    handleSubmit,
    clearErrors,
    setError,
    resetField,
    formState: { errors, isValid, isDirty },
  } = useForm({
    defaultValues: {},
    //錯誤驗證時機
    mode: "all",
  });

  useEffect(() => {
    axios_getCompanyList();
  }, []);

  useEffect(() => {
    const isFromChildPage = sessionStorage.getItem("fromProductProcessSettingsChildPage");
    if (currentCompanySeq !== "" && isFromChildPage) {
      axios_queryProductProcessList({ companySeq: currentCompanySeq });
      setValue("companySeq", currentCompanySeq);
      sessionStorage.removeItem("fromProductProcessSettingsChildPage");
    }
  }, [currentCompanySeq]);

  //組織邊界廠商清單
  const axios_getCompanyList = () => {
    checkLoading(loading);
    getCompanyList()
      .then((res) => {
        if (checkDpSuccess(res)) {
          const data = res.data.RespBody.companyList || [];
          setCompanyPlaceList(data);
          if (getCompanyType() === "A" && data.length > 0) {
            const firstCompany = data[0];
            setValue("companySeq", firstCompany.companySeq);
            const match = data.find((item) => item.companySeq === firstCompany.companySeq);
            setExistPlaceList(match?.placeList);
            setSelectPlaceList(match);
            setCurrentCompanySeq(firstCompany.companySeq);
            setCurrentCompanyName(firstCompany.companyName);
            axios_queryProductProcessList({ companySeq: firstCompany.companySeq });
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 設備製程列表查詢
  const axios_queryProductProcessList = (reqBody, readMore = false) => {
    checkLoading(loading);
    queryProductProcessList(reqBody)
      .then((res) => {
        if (checkDpSuccess(res)) {
          const data = res.data.RespBody.companiesProduct || [];
          if (data.length > 0) {
            setLastRowsSeq(data[data.length - 1].offeringsId);
            setRows((prev) => (readMore ? [...prev, ...data] : [...data]));
          } else if (!readMore) {
            setRows([]);
          }
        }
      })
      .finally((fin) => {
        checkLoading(loading, false);
      });
  };

  // 查看更多
  const btnReadMore = () => {
    let reqBody = {
      companySeq: getValues("companySeq"),
      offeringsId: lastRowsSeq,
    };
    axios_queryProductProcessList(reqBody, true);
  };

  const onSubmit = (data) => {
    axios_queryProductProcessList({ companySeq: data.companySeq });
  };

  const actionBodyTemplate = (rowData, props) => {
    if (rowData) {
      return (
        <>
          <Button
            tooltip={t(`button.detail`)}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              actionItem(rowData, "detail");
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-eye" />
          </Button>

          {/* <Button
            tooltip={t("button.delete")}
            tooltipOptions={{ position: "top" }}
            rounded
            text
            severity="secondary"
            className="p-button-icon-only"
            onClick={() => {
              // deleteItem(rowData, "E");
              setDelDialog(true);
              setDelObj(rowData);
            }}
          >
            <FontAwesomeIcon icon="fa-solid fa-trash" />
          </Button> */}
        </>
      );
    }
  };

  // 設備製程詳情編輯
  const actionItem = (data = {}, action = "edit") => {
    setItemObj(data);
    setAction(action);
    navigate("detail");
  };

  const tooltipBodyTemplate = (rowData, props) => {
    const field = props?.field;
    const value = rowData?.[field] || "";

    if (!value) return null;

    // Tooltip 顯示內容：如果是特定欄位就取對應 name，否則直接顯示 value
    const tooltipMap = {
      cnCode: rowData?.cnCodeName,
      hsCode: rowData?.hsCodeName,
    };
    const tooltipContent = tooltipMap[field] || value;

    // 顯示時做截斷
    const displayText = value.length > 15 ? `${value.substring(0, 15)}...` : value;

    return (
      <span
        ref={(el) => setTooltipTarget(el)}
        data-pr-tooltip={tooltipContent} // Tooltip 顯示完整文字
        data-pr-position="bottom"
        className="nameBody text-ellipsis"
      >
        {displayText}
      </span>
    );
  };

  return (
    <>
      {/*上半區*/}
      <div className="p-card bg-gray">
        <div className="p-card-body">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="grid">
              <div className="col-12 lg:col-12">
                <label htmlFor="placeName" className="form-label required">
                  {t("organName")}
                </label>
                <Controller
                  name="companySeq"
                  control={control}
                  rules={{ required: { value: true, message: t("validation.required") } }}
                  render={({ field, fieldState }) => (
                    <Dropdown
                      loading={loading.toString() === "true" ? 1 : 0}
                      filter
                      disabled={getCompanyType() === "A"}
                      appendTo={"self"}
                      optionLabel="companyName"
                      optionValue="companySeq"
                      value={field.value}
                      virtualScrollerOptions={{ itemSize: 40 }}
                      defaultValue={""}
                      placeholder={t("plz_chs")}
                      name="companySeq"
                      control={control}
                      options={companyPlaceList}
                      className={`w-full ` + classNames({ "p-invalid": fieldState.error })}
                      onChange={(event) => {
                        field.onChange(event.value);
                        setCurrentCompanySeq(event.value);
                        const filterData = companyPlaceList?.filter((item) => item.companySeq === event.value)[0];
                        setSelectPlaceList(filterData);
                        setCurrentCompanyName(filterData.companyName);
                      }}
                    />
                  )}
                />
                {getFormErrorMessage(errors, "companySeq")}
              </div>
            </div>

            <div className="col-12 gap-2 flex-all-center">
              <Button type="submit" label={t("button.query")} />
            </div>
          </form>
        </div>
      </div>
      {/*下半區*/}
      <div className="p-card">
        <div className="p-card-body">
          <DataTable
            stripedRows
            resizableColumns
            className="white-data-table hover-highlight no-shadow"
            tableStyle={{ minWidth: "55rem" }}
            footer={
              rows?.length > 0 && <PrimeTableFooter rowDataList={rows} isShowMore={true} btnReadMore={btnReadMore} />
            }
            emptyMessage={<NoInfo panel="table" />}
            value={rows}
          >
            <Column field="productName" header={t("productName")} body={tooltipBodyTemplate}></Column>
            <Column field="productEName" header={t("enName")} body={tooltipBodyTemplate}></Column>
            <Column field="productTypeName" header={t("type")}></Column>
            <Column field="hsCode" header="HS Code" />
            <Column field="cnCode" header="CN Code" body={tooltipBodyTemplate} />
            <Column header={t("action_type")} body={actionBodyTemplate}></Column>
          </DataTable>
        </div>
      </div>
      {tooltipTarget && <Tooltip mouseTrack target=".nameBody" position="bottom" event="hover" />}
      {/*刪除*/}
      {/* <PrimeConfirmDialog
        visible={delDialog}
        onClose={() => {
          setDelDialog(false);
          setDelObj({});
        }}
        onConfirm={() => {
          axios_deleteEquipmentProcess();
        }}
        title={t("button.delete")}
        bodyTemplate={
          <>
            <div className="form-label">
              {t("processName")}: {delObj?.processName}
            </div>
            <div className="form-label">
              {t("equipmentName")}: {delObj?.equipmentName}
            </div>
            <div className="form-label">
              {t("place_name")}: {delObj?.placeName}
            </div>
          </>
        }
      /> */}
    </>
  );
}
